import { createRouter, createWebHistory } from "vue-router";
import { verifyToken } from "@/utils/request";
import { useUserinfoStore } from "@/store/userinfo";
import MainLayout from '@/layouts/MainLayout.vue'
import MobileLayout from '@/layouts/MobileLayout.vue'
import { isMobile } from '@/utils/device'

const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/login',
            name: 'login',
            component: () => import('@/views/LoginView.vue')
        },
        {
            path: '/admin',
            name: 'admin',
            component: () => import('@/views/AdminLayout.vue'),
            children: [
                {
                    path: 'user',
                    name: 'admin-user',
                    component: () => import('@/views/admin/AdminUser.vue')
                },
                {
                    path: 'post',
                    name: 'admin-post',
                    component: () => import('@/views/admin/AdminPost.vue')
                },
                {
                    path: 'comment',
                    name: 'admin-comment',
                    component: () => import('@/views/admin/AdminComment.vue')
                },
                {
                    path: 'notification',
                    name: 'admin-notification',
                    component: () => import('@/views/admin/AdminNotification.vue')
                },
                {
                    path: 'category',
                    name: 'admin-category',
                    component: () => import('@/views/admin/AdminCategory.vue')
                },
                {
                    path: 'advert',
                    name: 'admin-advert',
                    component: () => import('@/views/admin/AdminAdvert.vue')
                },
                {
                    path: '',
                    redirect: { name: 'admin-user' }
                }
            ]
        },
        {
            path: '/',
            component: isMobile() ? MobileLayout : MainLayout,
            redirect: '/home',
            children: [
                {
                    path: 'home',
                    name: 'home',
                    component: () => import('@/views/HomeView.vue')
                },
                {
                    path: 'profile',
                    name: 'profile',
                    component: () => import('@/views/ProfileView.vue')
                },
                {
                    path: 'notifications',
                    name: 'notifications',
                    component: () => import('@/views/NotificationsView.vue')
                },
                {
                    path: 'user-info',
                    name: 'user-info',
                    component: () => import('@/views/UserInfoView.vue')
                },
                {
                    path: 'dynamic',
                    name: 'dynamic',
                    component: () => import('@/views/DynamicView.vue')
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    const userStore = useUserinfoStore()
    if (to.path !== '/login' && !userStore.token) {
        next('/login')
    } else {
        next()
    }
})

export default router